// JS
import React from 'react';

// COMPONENT
const ProductShipping = ({ data }) => {
  return (
    <div className={'product-shipping'} id="product-shipping-content-panel">
      {data && (
        <div className="product-shipping-container" key={data.contentguid}>
          {/* UK */}
          <div className="product-shipping-content">
            <h3 className="product-shipping-title">{data.uk_delivery_title}</h3>
            <h4 className="product-shipping-sub-title">
              {data.uk_delivery_standard_title}
            </h4>
            <p>{data.uk_delivery_standard_info}</p>
            <h4 className="product-shipping-sub-title">
              {data.uk_delivery_express_title}
            </h4>
            <p>{data.uk_delivery_express_info}</p>
            <p className="product-shipping-sub-copy">
              {data.uk_delivery_sub_copy}
            </p>
          </div>
          {/* EU */}
          <div className="product-shipping-content">
            <h3 className="product-shipping-title">{data.eu_delivery_title}</h3>
            <h4 className="product-shipping-sub-title">
              {data.eu_delivery_express_title}
            </h4>
            <p>{data.eu_delivery_express_info}</p>
            <p className="product-shipping-sub-copy">
              {data.eu_delivery_sub_copy}
            </p>
          </div>
          {/* ROW */}
          <div className="product-shipping-content">
            <h3 className="product-shipping-title">
              {data.row_delivery_title}
            </h3>
            <h4 className="product-shipping-sub-title">
              {data.row_delivery_express_title}
            </h4>
            <p>{data.row_delivery_express_info}</p>
            <p className="product-shipping-sub-copy">
              {data.row_delivery_sub_copy}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductShipping;
